import React, { useState } from 'react';
import styled from 'styled-components';

const CollapsibleContainer = styled.div`
    /* Add styles for the collapsible container */
`;

const CollapsibleButton = styled.button`
    /* Add styles for the button */
    /*background: none;
    border: none;
    color: white;
    cursor: pointer;
    font-size: 1.5rem;
    padding: 0;
    margin: 0;
    text-align: right;*/
`;

const CollapsibleContent = styled.div`
    /* Add styles for the content */
    /*overflow: hidden;*/
    /*transition: max-height 0.3s ease-out;*/
    /*max-height: ${(props) => (props.isOpen ? '600px' : '0px')};*/
/* keep your animation */
  transition: max-height 0.3s ease-out;

  /* open/close */
  max-height: ${(props) => (props.isOpen ? '50vh' : '0px')};

  /* IMPORTANT: allow scrolling when open */
  overflow-y: ${(props) => (props.isOpen ? 'auto' : 'hidden')};
  -webkit-overflow-scrolling: touch;

  /* optional: prevents scrolling the page behind it on iOS */
  overscroll-behavior: contain;
`;

const Collapsible = ({ children, isOpen, onToggle }) => {
    return (
        <CollapsibleContainer>
        
            <CollapsibleButton onClick={onToggle}>
                {isOpen ? '▲' : '▼'} 
            </CollapsibleButton>
            <CollapsibleContent isOpen={isOpen}>
                {children}
            </CollapsibleContent>
        </CollapsibleContainer>
    );
};

export default Collapsible;